import { useState } from "react";
import InputNumber from "../InputNumber";
import { ColumnFilterWrapper } from "./ColumnFilterWrapper";

type Props = {
  confirm: () => void;
  close: () => void;
};

type NumberRangeFilterProps = {
  title?: string;
  placeholder?: string;
  selectedRange?: {
    from?: number;
    to?: number;
  };
  handleRangeChange: (range: { from?: number; to?: number }) => void;
  props: Props;
  before?: React.ReactNode;
  filterCount?: number;
  sortActive?: boolean;
  sortDirection?: "asc" | "desc";
  onSortChange?: (dir?: "asc" | "desc") => void;
  sortAscLabel?: string;
  sortDescLabel?: string;
  onReset?: () => void;
};

const NumberRangeFilter = ({
  title,
  placeholder = "Enter range",
  selectedRange = {},
  handleRangeChange,
  props: { confirm, close },
  before,
  filterCount,
  sortActive,
  sortDirection,
  onSortChange,
  sortAscLabel,
  sortDescLabel,
  onReset,
}: NumberRangeFilterProps) => {
  const [fromValue, setFromValue] = useState<number | undefined>(
    selectedRange.from
  );
  const [toValue, setToValue] = useState<number | undefined>(selectedRange.to);

  const cleanPlaceholder = placeholder
    ? placeholder.replace(/^(Select|Enter)\s+/i, "")
    : "";
  const displayTitle =
    title ||
    (cleanPlaceholder && cleanPlaceholder !== "range"
      ? cleanPlaceholder.charAt(0).toUpperCase() + cleanPlaceholder.slice(1)
      : undefined);

  const isFiltered = selectedRange.from !== undefined || selectedRange.to !== undefined;

  const handleApply = () => {
    handleRangeChange({
      from: fromValue,
      to: toValue,
    });
    confirm();
  };

  const handleResetInternal = () => {
    setFromValue(undefined);
    setToValue(undefined);
    handleRangeChange({ from: undefined, to: undefined });
    if (onReset) onReset();
    confirm();
  };

  return (
    <ColumnFilterWrapper
      title={displayTitle}
      filterCount={filterCount ?? (isFiltered ? 1 : 0)}
      isFiltered={isFiltered}
      sortActive={sortActive}
      sortDirection={sortDirection}
      onSortChange={onSortChange}
      sortAscLabel={sortAscLabel}
      sortDescLabel={sortDescLabel}
      confirm={confirm}
      close={close}
      onApply={handleApply}
      onReset={handleResetInternal}
    >
      {before}
      <div style={{ padding: "4px 0" }}>
        <p style={{ margin: "0 0 6px 0", fontSize: 11, fontWeight: 700, textTransform: "uppercase", letterSpacing: "0.05em", color: "#9ba3b2" }}>
          Range
        </p>
        <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
          <div style={{ flex: 1 }}>
            <InputNumber
              style={{ width: "100%" }}
              placeholder="Min"
              value={fromValue}
              onChange={(value) =>
                setFromValue(typeof value === "number" ? value : undefined)
              }
            />
          </div>
          <span style={{ fontSize: 12, color: "#a3acb9", fontWeight: 500 }}>to</span>
          <div style={{ flex: 1 }}>
            <InputNumber
              style={{ width: "100%" }}
              placeholder="Max"
              value={toValue}
              onChange={(value) =>
                setToValue(typeof value === "number" ? value : undefined)
              }
            />
          </div>
        </div>
      </div>
    </ColumnFilterWrapper>
  );
};

export default NumberRangeFilter;

